import { createSlice } from "@reduxjs/toolkit";

const themeSlice = createSlice({
  name: "theme",
  initialState: {
    theme: "light", // Default theme,
  },
  reducers: {
    setTheme: (state, action) => {
      console.log("actionaction", action);
      state.theme = action.payload; // Update theme based on payload
    },
    toggleTheme: (state) => {
      state.theme = state.theme === "light" ? "dark" : "light"; // Toggle between light and dark
    },
  },
});

// Export actions for dispatching
export const { setTheme, toggleTheme } = themeSlice.actions;

// Export the reducer to include in the store
export default themeSlice.reducer;
